export function consiceInterval(interval) {
  if (interval === "month") {
    return "mo"
  } else if (interval === "year") {
    return "yr"
  } else {
    return null
  }
}
